export enum MapActionTypes {
  street = 'street',
  ruler = 'ruler',
}

export enum MapSideMenuType {
  stores = 'stores',
  starredBrands = 'starred-brands',
  more = 'more',
}
